import React, { useState, useEffect } from "react";
import DashboardUsageTable from "./components/DashboardUsageTable";
import Divider from "@material-ui/core/Divider";
import axios from "axios";


export default function RequestsMerchant() {
    // const [showFilter, setShowFilter] = React.useState(false);

    // function handleChange() {
    //   setShowFilter((key) => !key);
    // }

    const [error, setError] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [sortField, setSortField] = useState("id");
    const [orderBy, setOrderBy] = useState(false);
    const [rows, setRows] = useState([]);
    const [count, setCount] = useState(0);


    const onDashboards = () => {
        setIsLoaded(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}dashboard/usageEmployees`, {
                headers: {
                    "Accept-Language": 1,
                },
            })
            .then(
                ({ data }) => {
                    setIsLoaded(false);
                    setRows(data);
                    setCount(data);
                    setError(false);
                }

            ).catch((error) => {
                setIsLoaded(false);
                setError(true);
                setRows([]);
                setCount(0);
            });
    };


    useEffect(() => {
        onDashboards();
    }, []);

    return (
        <div className="row bg-white rounded table-design">
            <div className="col-12 d-flex align-items-center py-4">
                <h1 className="display-4 mb-0">The count of employees included in the app on Assets</h1>
                {/* <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        /> */}
            </div>
            <Divider className="w-100" />
            <DashboardUsageTable
                setSortField={setSortField}
                setOrderByTable={setOrderBy}
                sortField={sortField}
                orderBy={orderBy}
                isLoaded={isLoaded}
                error={error}
                rows={rows}
                count={count}
            />
        </div>
    );
}
